import {
  getCallsCommunicationAuthorities,
} from './CallsCommunicationAuthority';

import {
  getCallsSessionRegistry,
} from './CallsSessionRegistry';

import {
  getCallsConnectionAuthorities,
} from './CallsConnectionAuthority';

export interface CallsRuntimeVerificationResult {
  readonly passed: boolean;
  readonly communicationAuthoritiesVerified: number;
  readonly sessionsVerified: number;
  readonly connectionsVerified: number;
  readonly verifiedAt: string;
}

export function verifyCallsRuntime():
CallsRuntimeVerificationResult {
  const authorities =
    getCallsCommunicationAuthorities();

  const sessions =
    getCallsSessionRegistry();

  const connections =
    getCallsConnectionAuthorities();

  const authorityRecordsValid =
    authorities.length > 0 &&
    authorities.every(
      (record) =>
        record.governed === true &&
        record.capability.length > 0 &&
        record.authority === 'Calls Governor',
    );

  const sessionIds =
    sessions.map((record) => record.id);

  const sessionRecordsValid =
    sessions.length > 0 &&
    sessions.every(
      (record) =>
        record.id.length > 0 &&
        record.session.length > 0 &&
        record.category.length > 0,
    ) &&
    new Set(sessionIds).size === sessionIds.length;

  const connectionRecordsValid =
    connections.length > 0 &&
    connections.every(
      (record) =>
        record.governed === true &&
        record.connection.length > 0 &&
        record.authority === 'Calls Governor',
    );

  return Object.freeze({
    passed:
      authorityRecordsValid &&
      sessionRecordsValid &&
      connectionRecordsValid,
    communicationAuthoritiesVerified:
      authorities.length,
    sessionsVerified:
      sessions.length,
    connectionsVerified:
      connections.length,
    verifiedAt:
      new Date().toISOString(),
  });
}
